import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const minusIcon: SvgIconData = {
  viewBox: '0 0 40 40',
  element: <path d="M0 15.5H4.5a4 4 0 1 0 0 9h31a4 4 0 1 0 0-9" />,
};
